'use client'

import { useNavigation } from 'hooks/useNavigation/useNavigation'
import type { ORDER_TYPES } from 'my-purchases/constants/orderTypes'
import {
	BASE_PATHNAME,
	PURCHASE_DETAIL_PATHNAME,
} from 'my-purchases/constants/paths'
import { useSearchParams } from 'next/navigation'
import { useEffect } from 'react'
import { useSession } from 'session/src/hooks/useSession'

export function SessionController({
	children,
}: {
	children: React.ReactNode
}): React.ReactNode {
	const { logged } = useSession()
	const { navigate } = useNavigation()
	const searchParams = useSearchParams()

	useEffect(() => {
		if (logged) {
			const type = searchParams?.get('type') as ORDER_TYPES
			const purchaseId = searchParams?.get('purchaseId')

			if (type && purchaseId) {
				navigate(
					`${PURCHASE_DETAIL_PATHNAME}?type=${type}&purchaseId=${purchaseId}`
				)
				return
			}

			navigate(BASE_PATHNAME)
		}
	}, [logged, navigate])

	return children
}
